/* FRAGRANTA PDP v2 — Interaktionen (prompt: Menge +/-, EAN kopieren,
   Bildnavigation; dazu aktive Warenkorb-Rabatt-Stufe ohne Full-Reload
   und In-Cart-Zustand des CTA). Daten/i18n aus <script data-fpd-data>. */
(function () {
  'use strict';

  function initPdp(root) {
    var dataEl = root.querySelector('[data-fpd-data]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var i18n = data.i18n || {};

    function formatMoney(cents) {
      var format = data.moneyFormat || '€{{amount_with_comma_separator}}';
      var amount = (cents / 100).toFixed(2);
      var parts = amount.split('.');
      var dot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      var comma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var map = {
        amount: comma + '.' + parts[1],
        amount_no_decimals: comma,
        amount_with_comma_separator: dot + ',' + parts[1],
        amount_no_decimals_with_comma_separator: dot,
      };
      return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, k) { return map[k] != null ? map[k] : m; });
    }
    function tpl(str, repl) {
      var out = str || '';
      Object.keys(repl).forEach(function (k) { out = out.split('[' + k + ']').join(repl[k]); });
      return out;
    }

    /* ---- EAN kopieren ---- */
    root.querySelectorAll('[data-fpd-copy-ean]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var ean = btn.getAttribute('data-fpd-copy-ean');
        if (navigator.clipboard && ean) {
          navigator.clipboard.writeText(ean).then(function () {
            btn.classList.add('pd-copied');
            var old = btn.getAttribute('title');
            btn.setAttribute('title', i18n.copied || old);
            setTimeout(function () {
              btn.classList.remove('pd-copied');
              btn.setAttribute('title', old);
            }, 1600);
          });
        }
      });
    });

    /* ---- Bildnavigation (nur wenn mehrere Medien) ---- */
    var mainImg = root.querySelector('[data-fpd-main]');
    var mediaList = data.media || [];
    if (mainImg && mediaList.length > 1) {
      var mediaIndex = 0;
      function showMedia(i) {
        mediaIndex = (i + mediaList.length) % mediaList.length;
        mainImg.src = mediaList[mediaIndex];
      }
      root.querySelectorAll('[data-fpd-media-prev]').forEach(function (b) {
        b.addEventListener('click', function () { showMedia(mediaIndex - 1); });
      });
      root.querySelectorAll('[data-fpd-media-next]').forEach(function (b) {
        b.addEventListener('click', function () { showMedia(mediaIndex + 1); });
      });
    }

    /* ---- Menge → CTA-Label (nur freigeschaltet; net kommt nur dann im JSON) ---- */
    var qtyInput = root.querySelector('[data-fpd-qty]');
    var ctaLabel = root.querySelector('[data-fpd-cta-label]');
    var ctaButton = root.querySelector('.pd-cta');
    var inCartQty = 0;

    function updateCta() {
      if (!ctaLabel) return;
      var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      if (inCartQty > 0) {
        ctaLabel.textContent = tpl(i18n.ctaInCart, { count: inCartQty, qty: qty });
        if (ctaButton) ctaButton.classList.add('pd-in-cart');
      } else if (data.net) {
        ctaLabel.textContent = tpl(i18n.ctaAdd, { qty: qty, total: formatMoney(qty * data.net) });
        if (ctaButton) ctaButton.classList.remove('pd-in-cart');
      }
    }
    if (qtyInput) {
      qtyInput.addEventListener('change', updateCta);
      qtyInput.addEventListener('input', updateCta);
    }

    /* ---- Aktive Rabattstufe + In-Cart-Zustand nach Cart-Änderung.
       Ohne Full-Reload: /cart.js liefert den Warenkorbwert, die Stufen
       werden clientseitig markiert (Schwellen aus Section-Settings).
       Nur freigeschaltet — gesperrt gibt es weder Aktiv-Markierung
       noch CTA-Zustand. ---- */
    function refreshCartState() {
      if (!data.unlocked) return;
      fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var subtotal = (cart.items || []).reduce(function (sum, item) {
            if (item.product_type === 'mws_fee_generated') return sum;
            return sum + (item.original_line_price != null ? item.original_line_price : item.line_price || 0);
          }, 0);
          var tiers = data.tiers || [];
          var activeIdx = -1;
          tiers.forEach(function (t, i) { if (subtotal >= t.min * 100) activeIdx = i; });
          root.querySelectorAll('[data-fpd-tier]').forEach(function (row) {
            var idx = parseInt(row.getAttribute('data-fpd-tier'), 10);
            row.classList.toggle('active', idx === activeIdx);
          });
          root.querySelectorAll('[data-fpd-tier-base]').forEach(function (row) {
            row.classList.toggle('active', activeIdx === -1);
          });
          if (data.variantId) {
            inCartQty = (cart.items || []).reduce(function (n, item) {
              return item.variant_id === data.variantId ? n + item.quantity : n;
            }, 0);
          }
          updateCta();
        })
        .catch(function () { /* noop */ });
    }

    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, refreshCartState);
    }
    refreshCartState();

    /* ---- Weitere Referenzen (Recommendations, Fallback serverseitig) ---- */
    function loadRelated() {
      var sec = root.querySelector('[data-fpd-related]');
      if (!sec || sec.getAttribute('data-fpd-related-static') === 'true') return;
      var grid = sec.querySelector('[data-fpd-rel-grid]');
      var url = sec.getAttribute('data-url') + '.json?product_id=' + sec.getAttribute('data-product-id') + '&limit=10&intent=related';
      fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (res) {
          var all = res.products || [];
          var vendor = sec.getAttribute('data-vendor');
          /* Same brand only — a heading that names the brand must never show
             another vendor's products (spec 3.16). No same-brand results
             means the server-rendered brand cards stay as they are. */
          var picks = all.filter(function (p) {
            return (p.vendor || '').toLowerCase() === (vendor || '').toLowerCase();
          }).slice(0, 4);
          if (!picks.length) return;
          grid.innerHTML = picks.map(function (p) {
            var priceHtml;
            if (data.unlocked) {
              var cents = typeof p.price === 'number' ? p.price : Math.round(parseFloat(p.price) * 100);
              if (data.discountFactor > 0 && data.discountFactor < 1) cents = Math.round(cents * data.discountFactor);
              priceHtml = '<span class="pd-relprice">' + formatMoney(cents) + '</span>';
            } else {
              priceHtml = '<span class="pd-relprice pd-locked" aria-hidden="true">' + (i18n.priceDummy || '€ ––,––') + '</span>';
            }
            var img = p.featured_image
              ? '<img src="' + p.featured_image + '" alt="' + (p.title || '') + ' ' + (i18n.altSuffix || '') + '" width="300" height="300" loading="lazy">'
              : '<span class="ri-empty"></span>';
            var stock = '';
            if (data.unlocked) {
              stock = p.available
                ? '<span class="pd-relstock"><span class="dot"></span>' + (i18n.inStock || '') + '</span>'
                : '<span class="pd-relstock low"><span class="dot"></span>' + (i18n.outOfStock || '') + '</span>';
            }
            var name = p.title && p.vendor && p.title.toLowerCase().indexOf(p.vendor.toLowerCase()) === 0
              ? p.title.slice(p.vendor.length).trim()
              : p.title;
            return '<a class="pd-relcard" href="' + p.url + '"><span class="ri">' + img + '</span>' +
              '<span class="pd-relbody"><span class="pd-relbrand">' + p.vendor + '</span>' +
              '<span class="pd-relname">' + name + '</span>' +
              '<span class="pd-relfoot">' + priceHtml + stock + '</span></span></a>';
          }).join('');
          sec.hidden = false;
        })
        .catch(function () { /* noop */ });
    }
    loadRelated();

    initAuthenticityPanel(root);

    initCopyGuard(root);

    updateCta();
  }

  /* Copy protection for EAN and editorial copy (spec 3.3).
     Blocks copy and the context menu inside the marked regions only; a
     selection made elsewhere on the page keeps working, and so do links,
     form fields and keyboard navigation. This is a UI-level guard, not
     access protection — the text remains in the page source. */
  function initCopyGuard(root) {
    var regions = root.querySelectorAll('[data-fpd-noselect]');
    if (!regions.length) return;
    regions.forEach(function (region) {
      region.addEventListener('copy', function (e) {
        if (e.target.closest('a, button, input, textarea, select')) return;
        e.preventDefault();
      });
      region.addEventListener('contextmenu', function (e) {
        if (e.target.closest('a, button, input, textarea, select')) return;
        e.preventDefault();
      });
      region.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
  }

  /* Authenticity Promise — zentriertes Modal (Nachbesserung V2 §3.10).
     Backdrop wird einmalig als direktes Kind von <body> geportalt; öffnet
     über das Info-Icon, schließt über ×, Backdrop-Klick und Escape. Fokus
     wandert beim Öffnen ins Modal (Close-Button), beim Schließen zurück
     zum Info-Icon; Tab bleibt im Modal gefangen. */
  function initAuthenticityPanel(root) {
    var btn = root.querySelector('[data-fa-toggle]');
    var backdrop = root.querySelector('[data-fa-modal]') || document.getElementById(btn && btn.getAttribute('aria-controls'));
    if (!btn || !backdrop) return;
    if (backdrop.parentElement !== document.body) {
      document.body.appendChild(backdrop);
    }
    var closeBtn = backdrop.querySelector('[data-fa-close]');

    function isOpen() { return backdrop.classList.contains('fa-open'); }

    function focusables() {
      return backdrop.querySelectorAll('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    }

    function setOpen(open) {
      backdrop.classList.toggle('fa-open', open);
      backdrop.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        if (closeBtn) closeBtn.focus();
      } else {
        btn.focus();
      }
    }

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      setOpen(!isOpen());
    });
    if (closeBtn) closeBtn.addEventListener('click', function () { setOpen(false); });
    backdrop.addEventListener('click', function (e) {
      if (e.target === backdrop) setOpen(false);
    });
    document.addEventListener('keydown', function (e) {
      if (!isOpen()) return;
      if (e.key === 'Escape') { setOpen(false); return; }
      if (e.key === 'Tab') {
        var f = focusables();
        if (!f.length) return;
        var first = f[0];
        var last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        else if (!backdrop.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-fpd]').forEach(initPdp);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
